import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#7b7798",
        secondary: "#7b7798",
        accent: "#ff5252",
        error: "#f44336",
        info: "#2b1f27",
        success: "#7f9351",
        warning: "#fd8319",
      },
    },
  },
});
